import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model";

export class CreateJuzgadoRequest extends CreateKeyValueRequest{

  nombre!: string;
  domicilio!: string;
  telefono!: string;
  correo!: string;
  region!: string;
  idLocalidad!: number;
  idPais!: number;
  idJurisdiccion!: number;
  idFuero!: number;
  nominacion!: string;
  subnominacion!: string;
  competencia!: string;
  grado!: string;
  numero!: string;
  letra!: string;
  esActivo!: boolean;
  esSecretaria!: boolean;
  tieneMesaVirtual!: boolean;
  horarioAtencion!: string;
  urlSistemaGestion!: string;
}
